import { LineChart, Ruler, FileCheck } from "lucide-react";
import { DiamondMarketExplorer } from "@/components/DiamondMarketExplorer";
import { Reveal } from "@/components/Reveal";

const HOW_TO = [
  { icon: Ruler, title: "A range, not a point", body: "Wholesale trades in spreads. The band shows where comparable certified goods are changing hands — your exact quote depends on make, fluorescence, and the parcel." },
  { icon: LineChart, title: "Trend beats snapshot", body: "A soft month in a rising year is a buying window. Watch the 12-month line, not just today's number." },
  { icon: FileCheck, title: "The quote is the contract", body: "Index data orients you; the desk's firm quote — against a specific stone with a specific report — is what you trade on." },
];

export const ExplorerPage = ({ onRequestQuote }) => (
  <div className="pt-24" data-testid="explorer-page">
    <header className="mx-auto max-w-7xl px-6 pb-4 pt-16 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-4">Market Explorer</p>
        <h1 className="font-display max-w-3xl text-4xl font-light leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          The market, <span className="gold-text italic">in the open</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8BCC2] sm:text-lg">
          Most desks keep the index behind the counter. We put it on the table — indicative,
          dated, and refreshed daily — because informed buyers become long-term clients.
        </p>
      </Reveal>
    </header>

    <DiamondMarketExplorer onRequestQuote={onRequestQuote} />

    <section className="mx-auto max-w-7xl px-6 pb-16 lg:px-12" data-testid="explorer-how-to">
      <Reveal>
        <p className="eyebrow mb-4">How to read it</p>
      </Reveal>
      <div className="grid gap-6 md:grid-cols-3">
        {HOW_TO.map((h, i) => (
          <Reveal key={h.title} delay={i * 0.08}>
            <div className="glass-panel h-full rounded-2xl p-8 transition-all duration-500 hover:border-[#C9A24B]/40" data-testid={`how-to-${i}`}>
              <h.icon className="mb-4 h-5 w-5 text-[#C9A24B]" strokeWidth={1.5} />
              <h3 className="font-display text-xl text-white">{h.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#B8BCC2]">{h.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-10 rounded-2xl border border-[#C9A24B]/25 bg-[#C9A24B]/5 p-8" data-testid="explorer-methodology">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C9A24B]">Methodology & attribution</p>
          <p className="mt-3 text-sm leading-relaxed text-[#B8BCC2]">
            Figures shown are a simulated reference index maintained by Sunrays for orientation only —
            seeded from public market commentary, refreshed daily, and clearly dated at display. They are
            not a firm quote, not an offer, and not a scraped competitor feed. Licensed live index data
            (TheDiamondPrice / Caratlytics) will replace the simulation once keys are provisioned.
          </p>
        </div>
      </Reveal>
    </section>
  </div>
);
